"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    browserStorageManager: ()=>browserStorageManager,
    initBrowserStorageManager: ()=>initBrowserStorageManager
});
class BrowserStorage {
    storage;
    requestFrom;
    constructor(storage, requestFrom){
        this.storage = storage;
        this.requestFrom = requestFrom;
    }
    getItem(key) {
        return this.storage.getItem(key);
    }
    setItem(key, value) {
        this.storage.setItem(key, value);
    }
    removeItem(key) {
        this.storage.removeItem(key);
        this.storage.removeItem(`PennyInitialMessageSubmitted-${this.requestFrom}`);
    }
    updateUserMessageCount(count) {
        this.storage.setItem('PennyUserMessageCount', count);
    }
    getUserMessageCount() {
        const data = this.storage.getItem('PennyUserMessageCount');
        return parseInt(data, 10);
    }
    isInitialMessageSubmitted() {
        if (!this.storage) return true;
        return 'true' === this.storage.getItem(`PennyInitialMessageSubmitted-${this.requestFrom}`);
    }
    setInitialMessageSubmitted() {
        if (this.storage) this.storage.setItem(`PennyInitialMessageSubmitted-${this.requestFrom}`, 'true');
    }
}
const initBrowserStorageManager = ()=>{
    let browserStorage;
    return {
        initBrowserStorage: (requestFrom)=>{
            if ('undefined' == typeof window || !!browserStorage) return;
            browserStorage = new BrowserStorage(window.sessionStorage, requestFrom);
            return browserStorage;
        },
        getBrowserStorage: ()=>browserStorage
    };
};
const browserStorageManager = initBrowserStorageManager();
exports.browserStorageManager = __webpack_exports__.browserStorageManager;
exports.initBrowserStorageManager = __webpack_exports__.initBrowserStorageManager;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "browserStorageManager",
    "initBrowserStorageManager"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
